import { render, staticRenderFns } from "./RootGuest.vue?vue&type=template&id=6474cadc&scoped=true&"
import script from "./RootGuest.vue?vue&type=script&lang=js&"
export * from "./RootGuest.vue?vue&type=script&lang=js&"
import style0 from "./RootGuest.vue?vue&type=style&index=0&id=6474cadc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6474cadc",
  null
  
)

export default component.exports